// import Vue from 'vue'
// import Vuex from 'vuex'
import state from './state'
import * as mutations from './mutations'
import * as actions from './actions'
import createPersistedState from "vuex-persistedstate";
import { createStore } from 'vuex'

// Vue.use(Vuex)

export default createStore({
  state,
  getters: {
    getUserToken() {
        return state.userToken;
    },
    getRefreshTokenStartTime() {
        return state.tokenStartTime;
    }
  },
  mutations,
  actions,
  modules: {
  },
  plugins: [createPersistedState()]
})
